'use client'

import { MouseEventHandler } from 'react'
import styled, { css } from 'styled-components'

import ICandidato from '@/app/2023/consejo/types/ICandidato'
import { Lista } from '@/app/2023/consejo/types/listas'
import { colors, spaces } from '@/config/global-parameters'
import { paddedNumberFormatter } from '@/helpers/formatters'

import { IFilters } from '../Filter/types'
import NamedNumber from './NamedNumber'

export interface IByListSummary {
  className?: string
  candidates: ICandidato[]
  selected: ICandidato[]
  setList: (list: Lista) => void
  filters: IFilters
}

const { format } = paddedNumberFormatter

export interface IHeader {
  color: string
  name: string
  onClick?: MouseEventHandler
  opaque?: boolean
  shortName?: string
  showMore: boolean
  size: number
}

const Header = ({ color, name, onClick, opaque, shortName, showMore, size }: IHeader) => (
  <Wrapper>
    <HeaderDesktop
      color={color}
      name={name}
      number={format(size)}
      onClick={onClick}
      opaque={opaque}
      showMore={showMore}
    />
    <HeaderMobile
      color={color}
      name={shortName || name}
      number={format(size)}
      onClick={onClick}
      opaque={opaque}
      showMore={showMore}
    />
  </Wrapper>
)

const addBorder = css`
  border-bottom: 1px solid ${colors.colorGrey24};
`

const HeaderDesktop = styled(NamedNumber)<{ color?: string; showMore: boolean }>`
  color: ${({ color }) => color || 'inherit'};
  height: 100%;
  padding: ${spaces.xs} 0;
  width: 100%;
  cursor: pointer;
  ${({ showMore }) => showMore && addBorder}
  @media(max-width: ${spaces.tabletBreakpoint}) {
    display: none;
  }
`
const HeaderMobile = styled(HeaderDesktop)`
  display: none;
  @media (max-width: ${spaces.tabletBreakpoint}) {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    text-align: center;
    cursor: pointer;
  }
`

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`

export default Header
